import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Chip, Grid, IconButton, Tooltip } from "@mui/material";
import { memo, useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import showToast from '../../../components/Hot-Toast/showToast.js';
import { CustomTable } from '../../../components/customTable/customTable.js';
import { setControlAction } from '../../../slice/userSlice.js';
import { useTMutation } from '../../../utils/useTMutation';
import { useAccessControl } from '../../../components/AccessControl';
// import '../Profile/AdminStyling.css';
import { format } from "date-fns";


export const Role = ({ access }) => {
    const { userDetails } = useSelector(state => state.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [event, setEvent] = useState({})
    const [reload, setReload] = useState(false);
    const { isFullAccess } = useAccessControl(access);
    const { mutate } = useTMutation("/role/deleteRole", "delete", (data) => {
        if (data.STATUS) {
            console.log("asdsad", event)
            setReload((prev) => !prev);
            showToast("success", data.MESSAGE, 3000);
        } else {
            showToast("error", data.MESSAGE, 3000);
        }
    });

    const handleViewClinician = useCallback((row) => {
        dispatch(setControlAction('view'));
        const state = { ID: row.ID, }
        navigate(`/admin/clinician-users/view?${row.USER_TYPE}=${row.FULL_NAME}`, { state: state });
    }, [dispatch, navigate])
    const handleDelete = (row) => {

        Swal.fire({
            title: 'Delete!',
            text: `Would you like to delete ${row?.ROLE_NAME}?`,
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'OK'
        }).then(async (result) => {
            if (result.isConfirmed) {
                console.log('row', row);
                mutate({ ID: row.ID });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                showToast("info", "Deletion cancelled", 2000);
            }
        });

    };
    const columns = useMemo(() => {
        const baseColumns = [
            {
                name: 'Role Name',
                valuesName: "ROLE_NAME",
                selector: row => row.ROLE_NAME,
                reorder: true,
                sortable: true,
            },
            {
                name: 'Description',
                valuesName: "DESCRIPTION",
                selector: row => row.DESCRIPTION,
                reorder: true,
                sortable: true,

            },
            {
                name: 'User Type',
                valuesName: "USER_TYPE",
                selector: row => row.USER_TYPE,
                reorder: true,
                sortable: true,
            },
            {
                name: 'Created Date',
                valuesName: "CREATED_DATE",
                // selector: row => format(new Date(row.CREATED_DATE), 'MMM dd, yyyy'),
                selector: row => new Date(row.CREATED_DATE).toDateString(),

                sortable: true,
                reorder: true,
                center: true
            },

            {
                name: 'Status',
                valuesName: "STATUS",
                selector: row => row.STATUS,
                sortable: true,
                reorder: true,
                center: true,
                cell: row => (
                    <Chip
                        sx={{
                            backgroundColor: row.STATUS === 'Active' ? '#d0fae4' : '#f0f5f8',
                            color: row.STATUS === 'Active' ? '#059669' : '#8794a6',
                        }}
                        size="small"
                        label={row.STATUS}
                    />

                ),
            },

        ];

        if (isFullAccess) {
            baseColumns.push({
                name: 'Actions',
                button: true,
                cell: row => (
                    <div style={{ display: "flex", gap: "5px" }}>

                        <Tooltip title="Edit Role">
                            <IconButton size="small" >
                                <EditOutlinedIcon
                                    color='success'
                                    onClick={() => navigate(`/${userDetails?.USER_TYPE}/add-role/${row.ID}`)}
                                />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Role">
                            <IconButton size="small" color="error" onClick={() => handleDelete(row)}>
                                <DeleteOutlineOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                    </div>
                ),
                reorder: true,
                center: true
            });
        }
        return baseColumns;
    }, [isFullAccess, handleViewClinician, handleDelete, navigate]);


    return (
        <>
            <Grid item lg={12} mb={2} mt={4}>
                <CustomTable
                    key={reload}
                    column={columns}
                    event={(e) => setEvent(e)}
                    url={"/role/fetchRoles"}
                    headline={"Roles"}
                    buttonText={"Add Role"}
                    add={isFullAccess ? `/${userDetails?.USER_TYPE}/add-role` : undefined}
                    showProfileStatusFilter={true}
                />
            </Grid>
        </>
    );
};

export default memo(Role);
